<template>

  <v-dialog :value="value" @input="$emit('input')" :width="width || '290px'">
    <v-card>
      <v-card-text class="pt-10"><h2>{{ text }}</h2></v-card-text>
      <v-layout row wrap>
        <v-flex pl-10 xs8 sm8 md8 lg8>
          <v-text-field color="primary" outlined label="Organization name" v-model="organization.name"/>
        </v-flex>
        <v-flex pl-10 xs8 sm8 md8 lg8>
          <v-text-field color="primary" outlined label="Currency, i.e. $ ‎€ £" v-model="organization.currency"/>
        </v-flex>
        <v-flex pl-10 xs8 sm8 md8 lg8>
          <v-text-field color="primary" outlined label="Location Name" v-model="organization.locations[0].name"/>
        </v-flex>
        <v-flex pl-10 xs8 sm8 md8 lg8>
          <v-text-field color="primary" outlined label="Location Address" v-model="organization.locations[0].address"/>
        </v-flex>
        <v-flex pl-10 xs8 sm8 md8 lg8>
          <v-text-field color="primary" outlined label="Owner's email" v-model="organization.members[0]"/>
        </v-flex>
        <v-btn class="pt-5 pb-5 pt-9 pl-8 pr-8 ml-3" dark color="primary" @click="addOrganization(organization)">
          <p>Save</p>
        </v-btn>
      </v-layout>
    </v-card>
  </v-dialog>

</template>

<script>

export default {
  props: ['value', 'text', 'width'],
  data: () => ({
    organization: {
      name: '',
      currency: '',
      locations: [ { name: '', address: '' } ],
      sheets: { deltaExport: '', landscapeExport: '', portraitExport: '' },
      members: [ '' ]
    }
  }),
  methods: {
    addOrganization () {
      this.$emit('input', this.organization)
    }
  },
  closeDialog () {
    this.$emit('input')
  }
}
</script>

<style lang="scss" scoped>

</style>
